import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'

// http://www.biliyu.com/article/1837.html
// https://blog.csdn.net/lily__an/article/details/89210853

Vue.use(Vant)
